export const DOMAIN_COLORS = [
  'BLUE',
  'RED',
  'ORANGE',
  'GREEN',
  'PURPLE',
  'TEAL',
  'PINK',
  'GRAY'
] as const;

export type DomainColor = typeof DOMAIN_COLORS[number];
export type DomainColorTone = 1 | 2 | 3 | 4 | 5;

export const DOMAIN_COLOR_PALETTES: Record<DomainColor, readonly [string, string, string, string, string]> = {
  BLUE:   ['#dbeafe', '#93c5fd', '#3b82f6', '#1d4ed8', '#1e3a8a'],
  RED:    ['#fee2e2', '#fca5a5', '#ef4444', '#b91c1c', '#7f1d1d'],
  ORANGE: ['#ffedd5', '#fdba74', '#f97316', '#c2410c', '#7c2d12'],
  GREEN:  ['#dcfce7', '#86efac', '#22c55e', '#15803d', '#14532d'],
  PURPLE: ['#f3e8ff', '#d8b4fe', '#a855f7', '#7e22ce', '#581c87'],
  TEAL:   ['#ccfbf1', '#5eead4', '#14b8a6', '#0f766e', '#134e4a'],
  PINK:   ['#fce7f3', '#f9a8d4', '#ec4899', '#be185d', '#831843'],
  GRAY:   ['#f3f4f6', '#d1d5db', '#9ca3af', '#4b5563', '#1f2937']
};

export function domainColorHex(color: DomainColor, tone: DomainColorTone = 3): string {
  return DOMAIN_COLOR_PALETTES[color][tone - 1];
}

export function domainPriorityTone(priority: number | null | undefined): DomainColorTone {
  if (priority === null || priority === undefined) return 3;
  if (priority === 1) return 5;
  if (priority === 2) return 4;
  if (priority === 3) return 3;
  if (priority === 4) return 2;
  return 1;
}

export function domainPriorityHex(
  color: DomainColor,
  priority: number | null | undefined
): string {
  return domainColorHex(color, domainPriorityTone(priority));
}
